/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import type { BaseQueryMeta } from '@reduxjs/toolkit/dist/query/baseQueryTypes'

export function transformResponseWithHttpStatus<R>(
  response: R,
  meta: BaseQueryMeta<any>
) {
  return {
    data: response,
    status: meta.response?.status,
    statusText: meta.response?.statusText,
  } as Response.CustomResponse<R>
}
